import { CancelOutlined } from "@mui/icons-material";
import { Alert } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { devLog } from "utils/devLog";

const searchTypeMap = new Map();

function R66MemberSearchForm(props) {
  const { t } = useTranslation();
  const formRef = useRef();
  const [last8Vin, setLast8Vin] = useState(props.last8Vin || "");
  const [odometer, setOdometer] = useState(props.odometer || "");

  const [moreThanEightVin, setMoreThanEightVin] = useState(false);
  const [odometerTooLong, setOdometerTooLong] = useState(false);
  const [vinIsTooShort, setVinIsTooShort] = useState(false);

  const [searchTypes, setSearchTypes] = useState([
    { key: "LAST8_VIN", value: t("ATF.ContractSearch.DropdownOptions3") },
    // { key: "LICENSE_PLATE", value: t("ATF.ContractSearch.DropdownOptions2") },
    // { key: "VEHICLE_ID", value: t("ATF.ContractSearch.DropdownOptions1") },
  ]);

  const [selectedSearchTypes, setSelectedSearchTypes] = useState("LAST8_VIN");

  useEffect(() => {
    devLog(selectedSearchTypes);
    // setVehicleId(vehicleId);
    // setLicensePlate(licensePlate);
    setLast8Vin(last8Vin);
  }, [selectedSearchTypes]);

  useEffect(() => {
    if (typeof props.onFormUpdated === "function") {
      props.onFormUpdated({
        odometer: odometer,
        last8Vin: last8Vin,
        searchType: selectedSearchTypes,
      });
    }
  }, []);

  const onSubmit = (e) => {
    devLog("onSubmit", e);
    e.preventDefault();
    if (typeof props.onFormSubmit === "function") {
      props.onFormSubmit({
        last8Vin: last8Vin,
        odometer: odometer,
        searchType: selectedSearchTypes,
      });
    }
    return false;
  };

  const vinInputLength = (e) => {
    setMoreThanEightVin(false);
    if (e.target.value.length > 8) {
      e.target.value = e.target.value.slice(0, -1);
      setMoreThanEightVin(true);
      devLog("Vin Length error");
    }
  };

  const odometerLen = (e) => {
    setOdometerTooLong(false);
    if (e.target.value.length > 7) {
      e.target.value = e.target.value.slice(0, -1);
      setOdometerTooLong(true);
      devLog("Odometer Length error");
    }
  };

  return (
    <>
      <div className="formContainer">
        <form ref={formRef} onSubmit={onSubmit} className="form">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
              background: "#303030",
              color: "white",
              padding: "6px 12px 6px 12px",
              border: "1px solid rgba(0, 0, 0, 0.15)",
              borderRadius: ".25rem",
            }}
          >
            Last 8 Digits of VIN
          </div>

          {/*Last 8 VIN*/}
          {selectedSearchTypes === "LAST8_VIN" && (
            <>
              <div className="group-1">
                <div className="label">{t("ATF.ContractSearch.DropdownOptions3")}:</div>
                <input
                  type="text"
                  placeholder={t("ATF.ContractSearch.DropdownOptions3")}
                  name="last8Vin"
                  className="input form-control required"
                  value={last8Vin}
                  onChange={(e) => {
                    setMoreThanEightVin(false);
                    vinInputLength(e);
                    setLast8Vin(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
              {moreThanEightVin && <Alert severity="error">{t("description.VinInputErrorMsg")}</Alert>}
            </>
          )}

          {/* Odometer */}
          {selectedSearchTypes === "LAST8_VIN" && (
            <>
              <div className="group-1">
                <div className="label">{t("description.ConfirmCustomerOdometer1")}:</div>
                <input
                  type="number"
                  placeholder={t("description.ConfirmCustomerOdometer1")}
                  name="odometer"
                  className="input form-control required"
                  value={odometer}
                  onChange={(e) => {
                    setOdometerTooLong(false);
                    odometerLen(e);
                    setOdometer(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
              {odometerTooLong && <Alert severity="error">{t("description.OdometerInputErrorMsg")}</Alert>}
            </>
          )}

          <div className="footerContainer">
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={{
                  background: "#f4f4f4",
                  color: "black",
                  paddingLeft: 14,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  devLog("UI Cancel pressed");
                  if (typeof props.onUserCancel === "function") {
                    props.onUserCancel();
                  }
                }}
              >
                <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>
            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default R66MemberSearchForm;
